import { Box, styled } from '@mui/material';

export const ErrorNotFoundContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  padding: '10px',
}));
